import { registerCapability } from '../../platform/capability-registry';
import { ComputeBlock } from './block/ComputeBlock';
import { COMPUTE_ACTION_KEY_LIST, COMPUTE_FIELD_KEY_LIST } from './fieldKeys';
import { resolveComputePaths } from './resolvePaths';
import type { ComputeBlockOptions } from './types';

registerCapability<ComputeBlockOptions>({
  key: 'compute',
  fields: [...COMPUTE_FIELD_KEY_LIST],
  actions: [...COMPUTE_ACTION_KEY_LIST],
  component: ComputeBlock,
  defaultPaths: (prefix) => resolveComputePaths(prefix),
  resolvePaths: (prefix, options) => resolveComputePaths(prefix, options),
});
